export * from './faq-accordion.component';
